import React,  { useRef, useEffect, useState }from 'react';
import { useSelector } from 'react-redux';

import { errorNotification, handleApiError, isObjectEmpty, successNotification } from 'utils';

import IconButton from 'components/common/IconButton';
import { createAnswerEpst, createQuestionEpst, fetchEpstLastQuestion, fetchEpstQuestionAnswersById, updateEpstAnswerById, updateEpstQuestionById, updateEpstQuestionMediaById } from 'api/certifications/epst/questions';

import noImage from "../../../../assets/img/icons/no-image.png";  // Imagen por defecto si no hay audio
import noAudio from "../../../../assets/img/icons/no-audio.png";  // Audio por defecto si aplica
import UploadMedia from 'components/uploads/UploadMedia';


function QuestionModal({ question_id, action, handleClose, setLoading }) {
    const token = useSelector(state => state.authentication.user?.token);

    const [formQuestion, setFormQuestion] = useState({ answers: [{ option: '', is_correct: 1 }, { option: '', is_correct: 0 }] }); // Siempre inicializamos con dos respuestas
    const [selectedSection, setSelectedSection] = useState("");
    const [selectedLevel, setSelectedLevel] = useState("");
    const [selectedCandidate, setSelectedCandidate] = useState("");

    const [localPreview, setLocalPreview] = useState(null);


    const audioRef = useRef(null);

    useEffect(() => {
		if(token !== null && token !== undefined) {
            console.log("aqui");
            if(question_id > 0) 
                loadEpstQuestionById(question_id);
            else 
                loadEpstLastQuestion();
        }
        // eslint-disable-next-line
    }, [token, question_id]); 

    const loadEpstQuestionById = async (id) => {
        try {
            const response = await fetchEpstQuestionAnswersById(id, token);
            let { data } = response;
            if(data.status === 200) {
                setFormQuestion(data.message); 
                setSelectedSection(data.message.section_id);
                setSelectedLevel(data.message.level_id);
                setSelectedCandidate(data.message.candidate_type);
            }
        } catch(error) {
            handleApiError(error);
        }
    }

    const loadEpstLastQuestion = async (id) => {
        try {

            const response = await fetchEpstLastQuestion(token);
            let { data } = response;
            if(data.status === 200) {
                setFormQuestion({
                    ...formQuestion,
                    question_number: isObjectEmpty(data.message) ? data.message.number + 1 : 1
                });
            }
        } catch(error) {
            handleApiError(error);
        }
    }

    const handleCreateQuestion = async (data) => {
        if (formQuestion.answers.length < 2) {
            errorNotification("Es necesario agregar al menos dos respuestas.");
            return; // Detener el proceso si no hay al menos dos respuestas
        }
        try {
            const response = await createQuestionEpst(data, token);
            if(response.data.status === 201) {
                formQuestion.answers.forEach(answer => {
                    let data_2 = {
                        question_id: response.data.message,
                        option: answer.option,
                        is_correct: answer.is_correct
                    }
                    handleCreateAnswer(data_2);
                });
                successNotification("Pregunta creada con éxito.");
                handleCloseModal();
            }
        } catch(error) { 
            handleApiError(error);
        }
    }

    const handleCreateAnswer  = async (data) => {
        try {
            await createAnswerEpst(data, token);
        } catch(error) { 
            handleApiError(error);
        }
    }

    const handleUpdateQuestion  = async (id, data) => {
        try {
            const response = await updateEpstQuestionById(id, data, token);
            if(response.data.status === 200) {
                successNotification("Pregunta actualizado con éxito.");
                handleCloseModal();
            }
        } catch(error) { 
            handleApiError(error);
        }
    }

    const handleUpdateAnswer  = async (id, data) => {
        try {
            await updateEpstAnswerById(id, data, token);
        } catch(error) { 
            handleApiError(error);
        }
    }

    const handleActionUser = (e) => {
        e.preventDefault(); 
        if (e.target.form.checkValidity()) {
            if(action === "Nueva") {
                let data = {
                    section_id: selectedSection,
                    level_id: selectedLevel,
                    candidate_type: selectedCandidate,
                    number: formQuestion.question_number,
                    instruction: formQuestion.question_instruction,
                    question: formQuestion.question,
                    passage: formQuestion.passage,
                    points: formQuestion.question_points
                }
                console.log(data);
                handleCreateQuestion(data);
            } else {
                formQuestion.answers.forEach(answer => {
                    if (answer.hasOwnProperty('answer_id')) {
                        let data = {
                            question_id: question_id,
                            option: answer.option,
                            is_correct: answer.is_correct
                        }
                        handleUpdateAnswer(answer.answer_id, data);
                    } else {
                        let data = {
                            question_id: question_id,
                            option: answer.option,
                            is_correct: answer.is_correct
                        }
                        handleCreateAnswer(data);
                    }
                });
                let data = {
                    section_id: selectedSection,
                    level_id: selectedLevel,
                    candidate_type: selectedCandidate,
                    number: formQuestion.question_number,
                    instruction: formQuestion.question_instruction,
                    question: formQuestion.question,
                    points: formQuestion.question_points,
                    passage: formQuestion.passage
                }
                handleUpdateQuestion(question_id, data);
            }   
        } else errorNotification("Faltan campos requeridos.");
	}

    const handleChangeFormQuestion = (event) => {
		const { name, value } = event.target;
		setFormQuestion({
			...formQuestion,
			[name]: value,
		});
	};

    const handleSectionChange = (event) => {
		const selectedId = event.target.value;
		setSelectedSection(selectedId);  
	};

    const handleLevelChange = (event) => {
		const selectedId = event.target.value;
		setSelectedLevel(selectedId);  
	};

    const handleCandidateChange = (event) => {
		const selectedId = event.target.value;
		setSelectedCandidate(selectedId);  
	};

    const handleAnswerChange = (index, field, value) => {
        const updatedAnswers = [...formQuestion.answers];
        updatedAnswers[index][field] = value; // Actualiza la opción o si es correcta
        setFormQuestion(prevState => ({
            ...prevState,
            answers: updatedAnswers
        }));
    };

    const handleAddAnswer = () => {
        const newAnswer = { option: '', is_correct: 0 }; // Nueva respuesta sin `answer_id`
        setFormQuestion(prevState => ({
            ...prevState,
            answers: [...prevState.answers, newAnswer]
        }));
    };

    const handleDeleteAnswer = (index) => {
        const answerToDelete = formQuestion.answers[index];
        if (!answerToDelete.answer_id) {
            const updatedAnswers = formQuestion.answers.filter((_, i) => i !== index);
            setFormQuestion(prevState => ({
                ...prevState,
                answers: updatedAnswers
            }));
        }
    };

    const handleImageUpload = (newImage) => {
        if (newImage.startsWith('blob:')) {
            setLocalPreview(newImage); // vista previa temporal
        } else {
            setFormQuestion(prev => ({ ...prev, image: newImage }));
            setLocalPreview(null);
            updateQuestionMedia(formQuestion.question_id, newImage, "image");
        }
    };

    const updateQuestionMedia = async (questionId, imageName, type) => {
        let payload = {
            type: type,
            media: imageName
        }
        try {
            await updateEpstQuestionMediaById(questionId, payload, token);
        } catch(error) { 
            handleApiError(error);
        }
    };

    const handleAudioUpload = async (newAudio) => {
        setFormQuestion(prevState => ({
            ...prevState,
            audio: newAudio 
        }));

        // Asegurar que el reproductor se actualice
        if (audioRef.current) {
            audioRef.current.load();
        }

        if (!newAudio.startsWith('blob:')) {
            const newName = newAudio.replace(/\.[^/.]+$/, '');
            updateQuestionMedia(formQuestion.question_id, newName, "audio");
        }
    }

    const handleCloseModal = () => {
        document.getElementById('epstModal').classList.remove('show');
		document.querySelector('.modal-backdrop').remove();
        document.getElementById('epstModal').style.display = 'none';
        cleanForm();
        handleClose();
    }

    const cleanForm = () => {
        setFormQuestion({});
        setSelectedSection("");
        setSelectedLevel("");
        setSelectedCandidate("");
    };

    return(
        <div id="epstModal" className="modal modal-cover fade" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{action} Pregunta</h5>
                        <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <form id="formEpst" className="was-validated" >
                                <div className="row row-space-12">
                                    <div className="mb-3 row" >
                                        <div className="col-2">
                                            <label className="form-label">#</label>
                                            <input className="form-control" placeholder="#"
                                                id="question_number"
                                                name="question_number"
                                                type='number'
                                                value={formQuestion.question_number || ''}
                                                onChange={handleChangeFormQuestion}
                                                disabled />
                                        </div>
                                        <div className='col-xl-3'>
                                            <label className="form-label">Sección</label>
                                            <select className="form-select" name="section" onChange={handleSectionChange} value={selectedSection} required >
                                                <option value="">Seleccione un opción</option>
                                                <option value="1">Grammar</option>
                                                <option value="2">Reading</option>
                                                <option value="3">Listening</option>
                                                <option value="4">Writing</option>
                                                <option value="5">Speaking</option>
                                            </select>
                                        </div>
                                        <div className='col-xl-3'>
                                            <label className="form-label">Candidato</label>
                                            <select className="form-select" name="section" onChange={handleCandidateChange} value={selectedCandidate} required >
                                                <option value="">Seleccione un opción</option>
                                                <option value="1">Kids</option>
                                                <option value="2">Adults</option>
                                            </select>
                                        </div>
                                        <div className='col-xl-2'>
                                            <label className="form-label">Nivel</label>
                                            <select className="form-select" name="section" onChange={handleLevelChange} value={selectedLevel} required >
                                                <option value="">Seleccione un opción</option>
                                                <option value="1">Pre A1</option>
                                                <option value="2">A1</option>
                                                <option value="3">A2</option>
                                                <option value="4">B1</option>
                                                <option value="5">B2</option>
                                                <option value="4">C1</option>
                                                <option value="5">C2</option>
                                            </select>
                                        </div>
                                        
                                        <div className="col-2">
                                            <label className="form-label">Puntos</label>
                                            <input
                                                className="form-control"
                                                style={{ textAlign: 'right' }}
                                                placeholder="Puntos"
                                                id="question_points"
                                                name="question_points"
                                                type="text"
                                                value={formQuestion.question_points || ''}
                                                onChange={handleChangeFormQuestion}
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^0-9]/g, ''); // Solo permite números
                                                }}
                                                pattern="^[1-9]\d*$"
                                                title="Por favor ingresa un número positivo mayor o igual a 1"
                                                required />
                                        </div>
                                    </div>  
                                    <div className="mb-3 row" >
                                        <div className='col-xl-6'>
                                            <label className="form-label">Pregunta</label>
                                            <textarea className="form-control" 
                                                placeholder="Escribe tu pregunta aquí..."
                                                id="question"
                                                name="question"
                                                value={formQuestion.question || ''}
                                                onChange={handleChangeFormQuestion}
                                                required
                                                pattern=".*\S+.*"
                                                rows="3"
                                                cols="50">
                                            </textarea>
                                        </div>
                                        <div className='col-xl-6'>
                                            <label className="form-label">Instrucción</label>
                                            <textarea className="form-control" 
                                                placeholder="Escribe tu instrucción aquí.."
                                                id="question_instruction"
                                                name="question_instruction"
                                                value={formQuestion.question_instruction || ''}
                                                onChange={handleChangeFormQuestion}
                                                required                                                  
                                                pattern=".*\S+.*"
                                                rows="3"
                                                cols="50">
                                            </textarea>
                                        </div> 
                                    </div>
                                    {formQuestion.answers && Array.isArray(formQuestion.answers) && formQuestion.answers.map((answer, index) => (
                                        <div className="mb-3 row" key={index}>
                                            <div className='col-xl-11'>
                                                <label className="form-label">
                                                    Respuesta #{index + 1}
                                                    {index === 0 && (
                                                        <span className="badge bg-success ms-2">Correcta</span>
                                                    )}
                                                </label>
                                                <textarea
                                                    className="form-control"
                                                    placeholder="Opción"
                                                    value={answer.option || ''}
                                                    onChange={(e) => handleAnswerChange(index, 'option', e.target.value)}
                                                    required
                                                    rows="2"
                                                    cols="50"
                                                />
                                            </div>

                                            <div className='col-xl-1 d-flex align-items-center'>
                                                {/* El botón de eliminar solo aparece para respuestas nuevas (sin `answer_id`) */}
                                                {!answer.answer_id && (
                                                    <IconButton 
                                                        variant="falcon-danger"
                                                        size="sm"
                                                        icon="trash"
                                                        transform="shrink-3"
                                                        onClick={() => handleDeleteAnswer(index)}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                    {/* Botón para agregar una nueva respuesta */}
                                    <div className="mb-3 row">
                                        <div className="col-xl-12">
                                            <button type="button" className="btn btn-secondary" onClick={handleAddAnswer}>
                                                Agregar Respuesta
                                            </button>
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <div className="row">
                                            {/* Pasaje (Textarea) */}
                                            <div className='col-xl-3'>
                                                <label className="form-label mb-2">Pasaje</label>
                                                <textarea 
                                                    className="form-control" 
                                                    placeholder="Escribe el pasaje aquí..."
                                                    id="passage"
                                                    name="passage"
                                                    value={formQuestion.passage || ''}
                                                    onChange={handleChangeFormQuestion}
                                                    rows="7"
                                                    cols="50">
                                                </textarea>
                                            </div>
                                            {action === "Editar" && (
                                                <>
                                                    {/* Imagen JR */}
                                                    {formQuestion.candidate_type !== 2 && (
                                                        <div className='col-xl-3 d-flex flex-column align-items-center'>
                                                            <label className="form-label mb-2">Imagen JR</label>
                                                            <div 
                                                                className="d-flex align-items-center justify-content-center"
                                                                style={{ width: "150px", height: "150px", overflow: "hidden" }}
                                                            >
                                                                <img
                                                                    src={
                                                                        localPreview
                                                                            ? localPreview
                                                                            : formQuestion.image
                                                                            ? `${process.env.REACT_APP_CERTIFICATIONS_API}/files/download/epst/images/jr-${formQuestion.image}`
                                                                            : noImage
                                                                    }
                                                                    alt="Vista previa JR"
                                                                    className="img-fluid"
                                                                    style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Imagen normal */}
                                                    <div className='col-xl-3 d-flex flex-column align-items-center'>
                                                        <label className="form-label mb-2">Imagen</label>
                                                        <div 
                                                            className="d-flex align-items-center justify-content-center"
                                                            style={{ width: "150px", height: "150px", overflow: "hidden" }}
                                                        >
                                                            <img
                                                                src={
                                                                    localPreview
                                                                        ? localPreview
                                                                        : formQuestion.image
                                                                        ? `${process.env.REACT_APP_CERTIFICATIONS_API}/files/download/epst/images/${formQuestion.image}`
                                                                        : noImage
                                                                }
                                                                alt="Vista previa"
                                                                className="img-fluid"
                                                                style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                                                            />
                                                        </div>
                                                        <UploadMedia handleLoad={handleImageUpload} fileType="images" setLoading={setLoading} />
                                                    </div>

                                                    {/* Audio */}
                                                    <div className='col-xl-3 d-flex flex-column align-items-center'>
                                                        <label className="form-label mb-2">Audio</label>
                                                        <div 
                                                            className="d-flex align-items-center justify-content-center"
                                                            style={{ width: "100%", height: "150px", overflow: "hidden" }}
                                                        >
                                                            {!formQuestion.audio ? (
                                                                <img 
                                                                    src={noAudio} 
                                                                    alt="Sin audio disponible" 
                                                                    className="img-fluid"
                                                                    style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                                                                />
                                                            ) : (
                                                                <audio ref={audioRef} controls className="w-100">
                                                                    <source
                                                                        src={
                                                                            formQuestion.audio?.startsWith('blob:')
                                                                                ? formQuestion.audio
                                                                                : `${process.env.REACT_APP_CERTIFICATIONS_API}/files/download/epst/audios/${formQuestion.audio}.mp3`
                                                                        }
                                                                        type="audio/mpeg"
                                                                    />
                                                                    Tu navegador no soporta la reproducción de audio.
                                                                </audio>
                                                            )}
                                                        </div>
                                                        <UploadMedia handleLoad={handleAudioUpload} fileType="audios" setLoading={setLoading} />
                                                    </div>

                                                    
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="modal-footer">
                    <button type="button" className="btn btn-outline-default" onClick={handleCloseModal}>Cerrar</button>
                        <button type="button" className="btn btn-outline-theme" onClick={handleActionUser} form="formEpst" >Guardar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default QuestionModal;